import { WhatsappTemplatesPageLoading } from '@/views/notifications-center/whatsapp-templates/components/whatsapp-templates-route-loading';

export default WhatsappTemplatesPageLoading;
